import { render } from "./TenantServicesIndex.vue?vue&type=template&id=755e4e39&scoped=true"
import script from "./TenantServicesIndex.vue?vue&type=script&lang=js"
export * from "./TenantServicesIndex.vue?vue&type=script&lang=js"

import "./TenantServicesIndex.vue?vue&type=style&index=0&id=755e4e39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755e4e39"]])

export default __exports__